import { render, staticRenderFns } from "./returnshipmentlist.vue?vue&type=template&id=07936bfc&"
import script from "./returnshipmentlist.vue?vue&type=script&lang=js&"
export * from "./returnshipmentlist.vue?vue&type=script&lang=js&"
import style0 from "./returnshipmentlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports